export default {
  show() {
    return this.isSystemAdmin() || this.isDrugsAdmin();
  },
};
